import { useMemo } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Avatar component with fallback to initials.
 * Accepts either a URL (relative /api/uploads/... or absolute) or nothing.
 */
export default function Avatar({ src, name = "", size = 40, className = "", ring = false, testId }) {
  const initials = useMemo(() => {
    const parts = (name || "?").trim().split(/\s+/).slice(0, 2);
    return parts.map((p) => p[0] || "").join("").toUpperCase() || "?";
  }, [name]);

  const url = src && src.startsWith("/") ? `${API}${src}` : src;
  const ringCls = ring ? "ring-2 ring-[#00e5ff]/40 ring-offset-2 ring-offset-black" : "";

  if (!url) {
    return (
      <div
        className={`shrink-0 flex items-center justify-center border border-[#00e5ff]/40 bg-[#00e5ff]/[0.08] text-[#00e5ff] font-outfit font-bold uppercase tracking-wider ${ringCls} ${className}`}
        style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.32)) }}
        data-testid={testId}
        aria-label={name}
      >
        {initials}
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={name}
      className={`shrink-0 object-cover border border-white/10 bg-black ${ringCls} ${className}`}
      style={{ width: size, height: size }}
      data-testid={testId}
      loading="lazy"
    />
  );
}
